import { render } from "./CRMTaskDatatableActions.vue?vue&type=template&id=2e6e0df9&scoped=true"
import script from "./CRMTaskDatatableActions.vue?vue&type=script&lang=js"
export * from "./CRMTaskDatatableActions.vue?vue&type=script&lang=js"

import "./CRMTaskDatatableActions.vue?vue&type=style&index=0&id=2e6e0df9&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e6e0df9"]])

export default __exports__